import React, { useContext } from "react";
import {  MenuList, Typography } from "@material-ui/core";
import { PortalContext, Link, getCiaFromUrl, createCiaOrigenCookie } from "@portal/arq-portal-core";
import { makeStyles } from '@material-ui/core';
import useAlertas from "../hooks/AlertasHooks";
import { Alert } from '@material-ui/lab';

const useStyles = makeStyles(() => ({
    alertasList:{
        padding: '0px',
        margin: '1rem 0 0 0',
        listStyleType: 'none',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent:'flex-start',
        textAlign: 'center',
        marginLeft: '-5px',
        width: 'calc(100% + 10px)',

        '& .alertasListItem': {
            width:'calc(25% - 10px)',
            textAlign: 'center',
            float: 'left',
            display: 'flex',
            border: '1px solid #d6d8d8',
            padding: '16px 5px 18px 5px',
            boxSizing: 'border-box',
            marginBottom: '10px',
            alignItems: 'center',
            marginLeft: '5px',
            marginRight: '5px',
        },
    },
    alertaWrapper: {
        width: '100%',
        '& .alertaTitle':{
            fontSize: '12px',
            float: 'left',
            width: '100%',
            
        },
        '& .alertaCounter': {
            width: '100%',
            float: 'left',
            paddingTop: '10px',
            '& .alertaCounterLink': {
                color: '#dc0028',
                fontSize: '20px',
                fontFamily: 'CO-Bold',
                borderBottom: '1px solid #dc0028',
                '&:hover': {
                   color: '#b7788f', 
                   borderBottom: '1px solid #b7788f',
                   
                },
            },
            '& .texto':{
                fontSize: '18px',
            }
        },
    },
    noAlerts: {
        textAlign: "center",
        fontSize: '12px',
    },
    aviso: {
        margin: '1rem 0 0 0',
        color: '#e49218',
        backgroundColor: '#ffe7ca',
        borderRadius: '0px',
        fontSize: '12px',
        borderLeft: '5px solid #aa4813',
        paddingLeft: '10px',
        '& .MuiAlert-icon': {
            display: 'none',
        },
        '& .MuiAlert-message': {
            padding: '0px',
            display: 'flex',
            alignItems: 'flex-start',
        }, 
        '& i': {
            marginRight: '5px',
            fontSize: '28px'
        }
    },
    

    avisoIcono: {
        color: '#e49218'
      },
}))

export const AlertasList = (props:any) => {
    const {user, ciaGestiona} = useContext(PortalContext);
    const clases = useStyles(props);
    const cia = getCiaFromUrl();
    let datos = props.data; 

    if(!datos){
        if(ciaGestiona && ciaGestiona != ''){
            const {data} = useAlertas(user?user.id:"", ciaGestiona);
            datos = data;
        }
        else {
            let ciaOrigenCookie = createCiaOrigenCookie(ciaGestiona?ciaGestiona:"");
            const {data} = useAlertas(user?user.id:"", ciaOrigenCookie);
            datos = data;
        }
    }
    
    if(datos){    
        var alertas = datos? datos.Salida?.Alertas : [];
        var retrasos: any =  datos? datos.Salida?.Retrasos : null;
        return (
            <React.Fragment>
            { retrasos && (retrasos?.TareasRetrasadas > 0 || retrasos?.TareasRetrasadasHoy > 0) && 
                <Alert className={clases.aviso}>
                <i className='icon-aviso-fixed-2'></i>
                <span>
                    Tiene tareas {retrasos.Texto}:<br/>
                    <span>- {retrasos.TareasRetrasadas } tareas en retraso</span> <br/>
                    <span>- {retrasos.TareasRetrasadasHoy} tareas a realizar hoy</span><br/>
                </span>
                </Alert>
            }
            <MenuList className={clases.alertasList}>
                {!alertas&&<li><Typography className={clases.noAlerts} variant="body1" >No se han recuperado alertas</Typography></li>}
                {alertas && alertas.map((alerta:any, indx:number)=>{
                    if (!alerta) return null;
                    if (cia != 'SPU' || ( cia == 'SPU' &&  alerta.Orden == 0)){
                        if(alerta.Contador >= 0){
                            return <li className="alertasListItem" key={indx}>
                                <div className={clases.alertaWrapper} >
                                    <span className="alertaTitle">{alerta.Titulo}</span>
                                    <span className="alertaCounter">
                                        <Link to={alerta.UrlAcceso} className="alertaCounterLink" >{alerta.Contador}</Link>
                                    </span>
                                </div>
                            </li>
                        }
                        else 
                            return null;
                    }else{
                        if (alerta.Visible) {
                            let contador = (alerta.TieneContador && alerta.Contador != -1) ? alerta.Contador : "ver lista"
                            return <li className="alertasListItem" key={indx}>
                                <div className={clases.alertaWrapper} >
                                    <span className="alertaTitle">{alerta.Titulo}</span>
                                    <span className="alertaCounter">
                                        <Link to={alerta.UrlAcceso} className={ contador === "ver lista" ?  'alertaCounterLink texto': 'alertaCounterLink '} >{contador}</Link>
                                       
                                    </span>
                                </div>
                            </li> 
                        }
                        else
                            return null;
                    }
                })}  
            </MenuList>
            </React.Fragment>
        )
    }else{
        return <div>Recuperando datos...</div>;
    }
}

